import * as moment from 'moment';
import 'rc-dropdown/assets/index.css';
import * as React from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
import * as localeDa from 'react-intl/locale-data/da';
import * as localeDe from 'react-intl/locale-data/de';
import * as localeEn from 'react-intl/locale-data/en';
import * as localeEs from 'react-intl/locale-data/es';
import * as localeFr from 'react-intl/locale-data/fr';
import * as localeIt from 'react-intl/locale-data/it';
import * as localeNl from 'react-intl/locale-data/nl';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Alert from 'react-s-alert';
import 'react-tippy/dist/tippy.css';
import * as apx from './api/apxService';
import { HeaderBar } from './components/index';
import Report from './components/Report';
import ReportList from './components/ReportList';
import { getMessages, url } from './components/general/generalUtil';
import { languages, redirectToUrl } from './general/generalUtil';
import './stylesheets/site.css';

addLocaleData([...localeNl, ...localeEn, ...localeFr, ...localeDe, ...localeEs, ...localeIt, ...localeDa]);

class App extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      language: languages[navigator.language.split(/[-_]/)[0]] ? navigator.language.split(/[-_]/)[0] : 'en',
      user: null,
    };
  }

  onSelect = (lang: string) => {
    moment.locale(lang);
    this.setState({ language: lang });
  }

  async componentDidMount() {
    try {
      const user = await apx.get(apx.service.users, 'me');
      this.setState({ user });
    } catch (e) {
      const error:any = await e;
      if (error.code === 104 || error.code === 108) {
        redirectToUrl(`${url.pages}/login/?redirect=${encodeURIComponent(`${url.pages}/myreports/${location.hash}`)}`);
      } else {
        Alert.error(error.message, { position: 'bottom-right', effect: 'slide' });
      }
    }
  }

  public render() {
    if (this.state.user === null) {
      return <div className="loader"><i className="fa fa-spinner fa-pulse fa-fw loader-green" /></div>;
    }

    return (
      <IntlProvider locale={this.state.language} messages={getMessages(this.state.language)}>
        <div>
          <Alert stack={{ limit: 1 }} />
          <HeaderBar user={this.state.user} />
          <HashRouter>
            <Switch>
              <Route
                path="/"
                exact={true}
                render={
                  (props: any) => (<ReportList {...props} language={this.state.language} changeLanguage={this.onSelect} user={this.state.user} />)
                }
              />
              <Route
                path="/report/:id"
                render={
                  (props: any) => (<Report {...props} language={this.state.language} changeLanguage={this.onSelect} user={this.state.user} />)
                }
              />
            </Switch>
          </HashRouter>
        </div>
      </IntlProvider>
    );
  }
}

export default App;
